import { TableColumn, TableColumnType } from '@thehubz/client/core';

export class HistoryTableColumnData {
  static TABLE_DEFAULT_COLUMNS: TableColumn[] = [
    {
      sequence: 1,
      columnDef: 'action',
      header: $localize`Action`,
      class: 'w-[15%] min-w-[14rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
    },
    {
      sequence: 2,
      columnDef: 'createdAt',
      header: $localize`Date & time`,
      type: TableColumnType.date,
      class: 'w-[3%] min-w-[10rem] flex-grow-0',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
    },
    {
      sequence: 1,
      columnDef: 'createdBy',
      type: TableColumnType.createdByUserIcon,
      header: $localize`Responsible`,
      class: 'w-[3rem] min-w-[8rem] flex-grow-0',
      innerClass: '!mx-0',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      sticky: true,
      disableClick: true,
    },
    {
      sequence: 4,
      columnDef: 'oldValue',
      header: $localize`Old value`,
      class: 'w-[12%] min-w-[9rem]',
      innerClass: '!mx-0',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
    },
    {
      sequence: 5,
      columnDef: 'newValue',
      header: $localize`New value`,
      class: 'w-[15%] min-w-[8rem] max-w-[50ch]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      disableClick: true,
    },
  ];
}
